import { Component, ViewChild, OnInit, Input, AfterViewChecked } from '@angular/core';
import { EdaDialog, EdaDialogCloseEvent } from '@eda/shared/components/shared-components.index';
import { PanelChart } from '../panel-charts/panel-chart';
import { PanelChartComponent } from '../panel-charts/panel-chart.component';
import { BubblechartConfig } from '../panel-charts/chart-configuration-models/bubblechart.config';
import { StyleProviderService, ChartUtilsService } from '@eda/services/service.index';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EdaDialog2Component } from '@eda/shared/components/shared-components.index';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DropdownModule } from 'primeng/dropdown';

@Component({
  standalone: true,
  selector: 'app-bubblechart-dialog',
  templateUrl: './bubblechart-dialog.component.html',
  imports: [FormsModule, EdaDialog2Component, PanelChartComponent, CommonModule, ColorPickerModule, DropdownModule],
})
export class BubblechartDialog implements OnInit, AfterViewChecked {
  @ViewChild('PanelChartComponent', { static: false }) myPanelChartComponent: PanelChartComponent;
  @Input() controller;

  public dialog: EdaDialog;
  public panelChartConfig: PanelChart = new PanelChart();

  /** Fuente de verdad para colores por label */
  public assignedColors: { value: string | number; color: string }[] = [];
  private originalAssignedColors: { value: string | number; color: string }[] = [];

  public labels: Array<string | number> = [];
  public selectedPalette: { name: string; paleta: string[] } | null = null;
  public allPalettes: any = this.stylesProviderService.ChartsPalettes;
  public title = $localize`:@@ChartProps:PROPIEDADES DEL GRAFICO`;

  constructor(private stylesProviderService: StyleProviderService, private ChartUtilsService: ChartUtilsService) { }

  ngOnInit(): void {
    this.panelChartConfig = this.controller.params.panelChart;
  }

  ngAfterViewChecked(): void {
    if (!this.assignedColors.length && this.myPanelChartComponent?.componentRef) {
      setTimeout(() => {
        // Recuperar labels y colores del chart
        this.labels = this.myPanelChartComponent.componentRef.instance.firstColLabels;

        const chartAssignedColors: { value: string | number; color: string }[] =
          this.myPanelChartComponent.props.config.getConfig()['assignedColors'] || [];

        // Inicializar assignedColors desde chart o con negro por defecto
        this.assignedColors = this.labels.map(label => {
          const match = chartAssignedColors.find(c => c.value === label);
          return {
            value: label,
            color: match.color,
          };
        });

        // Guardar copia para cancelación
        this.originalAssignedColors = this.assignedColors.map(c => ({ ...c }));
      }, 0);
    }
  }

  /** Cierra el diálogo */
  onClose(event: EdaDialogCloseEvent, response?: any): void {
    this.controller.close(event, response);
  }

  /** Guardar configuración de colores */
  saveChartConfig(): void {
    const colorsForConfig = this.assignedColors.map(c => c.color);

    this.myPanelChartComponent.props.config.setConfig(new BubblechartConfig(colorsForConfig));
    this.myPanelChartComponent.props.config.getConfig()['assignedColors'] = [...this.assignedColors];
    this.myPanelChartComponent.changeChartType();

    this.onClose(EdaDialogCloseEvent.UPDATE, { colors: colorsForConfig });
  }

  /** Cancelar cambios y restaurar estado inicial */
  closeChartConfig(): void {
    this.assignedColors = this.originalAssignedColors.map(c => ({ ...c }));

    const colorsForConfig = this.assignedColors.map(c => c.color);
    this.myPanelChartComponent.props.config.setConfig(new BubblechartConfig(colorsForConfig));
    this.myPanelChartComponent.props.config.getConfig()['assignedColors'] = [...this.assignedColors];
    this.myPanelChartComponent.changeChartType();

    this.onClose(EdaDialogCloseEvent.NONE);
  }

  /** Cuando el usuario edita un color individual */
  handleInputColor(): void {
    const colorsForConfig = this.assignedColors.map(c => c.color);
    this.myPanelChartComponent.props.config.setConfig(new BubblechartConfig(colorsForConfig));
    this.myPanelChartComponent.props.config.getConfig()['assignedColors'] = [...this.assignedColors];
    this.myPanelChartComponent.changeChartType();
  }

  /** Aplicar paleta completa al chart */
  onPaletteSelected(): void {
    if (!this.selectedPalette) return;
    const length = this.labels.length;

    // Mapear paleta al número de labels
    const newColors: string[] = [];
    for (let i = 0; i < length; i++) {
      newColors.push(this.selectedPalette.paleta[i % this.selectedPalette.paleta.length]);
    }

    // Actualizar assignedColors
    this.assignedColors = this.labels.map((label, i) => ({
      value: label,
      color: newColors[i],
    }));

    // Sincronizar config y TreeMapConfig
    const colorsForConfig = this.assignedColors.map(c => c.color);
    this.myPanelChartComponent.props.config.setConfig(new BubblechartConfig(colorsForConfig));
    this.myPanelChartComponent.props.config.getConfig()['assignedColors'] = [...this.assignedColors];

    this.myPanelChartComponent.changeChartType();
  }
}
